<div class="grid grid-cols-1 gap-10 md:grid-cols-2">
  @for (plan of plans; track plan.type) {
    <div class="self-stretch rounded-md border border-gray-200 bg-white p-6 shadow-sm sm:p-8 flex flex-col h-full">
      <div class="flex justify-end min-h-8">
        @if (plan.badgeLabel) {
          <span class="inline-flex h-7 min-w-[136px] items-center justify-center whitespace-nowrap rounded-md bg-blue-100 px-3 text-xs font-medium font-['Inter'] uppercase leading-none text-blue-700">
            {{ plan.badgeLabel }}
          </span>
        } @else {
          <span class="invisible inline-flex h-7 min-w-[136px] items-center justify-center whitespace-nowrap rounded-md bg-blue-100 px-3 text-xs font-medium font-['Inter'] uppercase leading-none text-blue-700">
            Mais escolhido
          </span>
        }
      </div>

      <h3 class="self-stretch text-center text-gray-900 text-2xl font-semibold font-['Inter'] leading-9">
        {{ plan.title }}
      </h3>

      <p class="mt-3 min-h-[3.5rem] self-stretch text-center text-gray-500 text-lg font-normal font-['Inter'] leading-relaxed">
        {{ plan.subtitle }}
      </p>

      <div class="mt-5 flex min-h-[6.5rem] flex-col items-center justify-start text-center">
        <div class="flex items-baseline justify-center text-gray-900">
          <span class="text-3xl font-semibold">R$</span>
          <span class="text-5xl font-extrabold tracking-tight">{{ plan.price }}</span>
          <span class="ms-1 text-xl font-normal text-gray-500">{{ plan.suffix }}</span>
        </div>

        @if (plan.savingsLabel) {
          <div class="mt-3 text-center text-green-700 text-base font-semibold font-['Inter']">
            {{ plan.savingsLabel }}
          </div>
        } @else {
          <div class="mt-3 invisible text-center text-green-700 text-base font-semibold font-['Inter']">
            Economize R$98 por ano
          </div>
        }
      </div>

      <ul role="list" class="space-y-5 my-7">
        @for (feature of plan.features; track feature) {
          <li class="flex">
            <svg class="w-6 h-6 text-green-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5"/>
            </svg>
            <span class="ms-3 text-base font-normal leading-tight text-gray-500">{{ feature }}</span>
          </li>
        }
      </ul>

      <button
        type="button"
        class="mt-auto inline-flex w-full justify-center rounded-md bg-blue-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:opacity-50"
        [disabled]="isLoading"
        (click)="selectPlan(plan.type)">
        {{ plan.buttonLabel }}
      </button>

      @for (footerPoint of plan.footerPoints; track footerPoint) {
        <p class="self-stretch text-center text-gray-900 text-base font-normal font-['Inter'] leading-normal" [class.mt-4]="$first" [class.mt-2]="!$first">
          <svg class="w-6 h-6 text-green-800 inline-block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5"/>
          </svg>
          {{ footerPoint }}
        </p>
      }
    </div>
  }
</div>
